import { EVENT_TEMPLATES, type TemplateKind } from '../utils/eventTemplates';

interface TemplatePickerProps {
  value: TemplateKind;
  onChange: (kind: TemplateKind) => void;
}

/** Shared 8-button icon+label template grid — used by EventForm.tsx and ClusterReviewCard.tsx. */
export function TemplatePicker({ value, onChange }: TemplatePickerProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
      {EVENT_TEMPLATES.map(t => {
        const selected = value === t.kind;
        return (
          <button
            key={t.kind}
            type="button"
            onClick={() => onChange(t.kind)}
            aria-pressed={selected}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all border ${
              selected
                ? 'bg-indigo-600 text-white border-indigo-600'
                : 'bg-white text-slate-600 border-slate-200 hover:border-indigo-300 hover:bg-indigo-50'
            }`}
          >
            <span className="text-lg leading-none">{t.icon}</span>
            <span className="truncate">{t.label}</span>
          </button>
        );
      })}
    </div>
  );
}
